// Sample data + id generator.

import { todayISO, addDays } from "./dateUtils";

let counter = 0;
export const genId = () => {
  counter += 1;
  return `t_${Date.now().toString(36)}_${counter}`;
};

// A realistic mixed history relative to today.
export const buildSample = () => {
  const today = todayISO();
  return [
    { id: genId(), entry: addDays(today, -160), exit: addDays(today, -145) }, // ~16d
    { id: genId(), entry: addDays(today, -110), exit: addDays(today, -85) }, // ~26d
    { id: genId(), entry: addDays(today, -50), exit: addDays(today, -35) }, // ~16d
    { id: genId(), entry: addDays(today, -10), exit: null }, // open, current
  ];
};
